import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import {
  buyMainOffer,
  CreateOrderResponse,
  CreateSubscriptionResponse,
  captureOrder,
  continuePurchase,
  validateSubscription,
} from 'publisher/api/paypalRestApi'
import { pageSelectors } from 'publisher/store'
import { useState } from 'react'
import { PaymentButtonEntityInterface } from 'src/shared/entities/payment-button/payment-button.schema'
import usePage from '../usePage'
import usePaymentSubmit from './usePaymentSubmit'

export const usePaypalRestPaymentHandler = (
  entity:
    | OldEntityInterface
    | PaymentButtonEntityInterface
    | BookingPaidCalendarInterface,
) => {
  const { errors, isLoading, submit } = usePaymentSubmit(entity)
  const [orderHash, setOrderHash] = useState('')
  const pageId = usePage(pageSelectors.getPageId)

  const handleSubmit = async () => {
    return await submit<string>(async body => {
      const {
        data: { redirect },
      } = await buyMainOffer(pageId, {
        payment_form: body,
      })
      const res = await continuePurchase<
        CreateOrderResponse | CreateSubscriptionResponse
      >(redirect)
      if (res) {
        if (res.data.isBump && res.data.options.paypalLink) {
          window.location.assign(res.data.options.paypalLink)
          return
        }

        setOrderHash(res.data.options.hash)
        // TODO: fix submit return type to avoid using any
        if ('paypalOrderId' in res.data.options) {
          return res.data.options.paypalOrderId as any
        }
        return res.data.options.paypalSubscriptionId
      }
    })
  }

  return {
    errors,
    isLoading,
    handleSubmit,
    orderHash,
  }
}

export interface PayPalApprovedData {
  billingToken?: string | null
  facilitatorAccessToken?: string
  orderID: string
  payerID?: string | null
  paymentID?: string | null
  subscriptionID?: string | null
  authCode?: string | null
}

interface BumpPurchaseResponse {
  options: {
    paypalLink: string
  }
}

export const handleCaptureOrder = async (
  body: PayPalApprovedData,
  hash: string,
  isBumpChecked?: boolean,
) => {
  const { data } = await captureOrder({
    paypalOrderId: body.orderID,
    paypalPaymentId: body.paymentID,
    facilitatorAccessToken: body.facilitatorAccessToken,
    paypalPayerId: body.payerID,
    paymentSource: 'paypal',
    hash,
  })

  const redirect = data.redirect || data.redirectLink

  if (isBumpChecked) {
    const res = await continuePurchase<BumpPurchaseResponse>(redirect)
    if (res) {
      window.location.assign(res.data.options.paypalLink)
      return
    }
  }

  if (redirect) {
    window.location.assign(redirect)
  }
}

export const handleValidateSubscription = async (
  body: PayPalApprovedData,
  hash: string,
  isBumpChecked?: boolean,
) => {
  if (body.subscriptionID) {
    const { data } = await validateSubscription({
      paypalSubscriptionId: body.subscriptionID,
      hash,
    })

    const redirect = data.redirect || data.redirectLink

    if (isBumpChecked) {
      const res = await continuePurchase<BumpPurchaseResponse>(redirect)
      if (res) {
        window.location.assign(res.data.options.paypalLink)
        return
      }
    }

    if (redirect) {
      window.location.assign(redirect)
    }
  }
}
